import React, { Component } from 'react';

import { COLOR_RANGES } from 'data/static';
import { OnChangeType } from 'types/functions';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface Option {
    value: string | number | undefined; // Allow undefined as a valid value
    label: string;
}

interface ColorRangeSelectProps {
    className?: string;
    isMulti?: boolean;
    name: string;
    id?: string;
    placeholder?: string;

    value: string;
    onChange: OnChangeType;
    disabled?: boolean;
}

interface ColorRangeSelectState {
    selectedValue: string;
    options: object;
    openSelect: boolean;
    dropdownPosition: { top: number; left: number; bottom: number; right: number }; // Adjusted position
}

class ColorRangeSelect extends Component<ColorRangeSelectProps, ColorRangeSelectState> {
    private dropdownRef = React.createRef<HTMLDivElement>();
    private parentRef = React.createRef<HTMLDivElement>();

    constructor(props: ColorRangeSelectProps) {
        super(props);
        this.state = {
            selectedValue: props.value || 'warm',
            options: COLOR_RANGES,
            openSelect: false,
            dropdownPosition: { top: 0, left: 0, bottom: 0, right: 0 },
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (event: MouseEvent) => {
        if (
            this.dropdownRef.current &&
            !this.dropdownRef.current.contains(event.target as Node) &&
            this.parentRef.current &&
            !this.parentRef.current.contains(event.target as Node)
        ) {
            this.setState({ openSelect: false });
        }
    };

    handleChange = (value) => {
        const { name, onChange } = this.props;

        onChange(name, value);
    };

    renderColor = (name, palette) => {
        return (
            <div
                className="my-1 cursor-pointer w-full"
                onClick={() => {
                    this.selectColor(name);
                }}
                key={name}
            >
                <div className="flex gap-2">
                    <div className="w-12 capitalize">{name}</div>
                    <div className="flex pt-1">
                        {palette.map((color, index) => (
                            <div
                                className="w-6 h-3"
                                key={index}
                                style={{
                                    backgroundColor: `rgb(${color.join(',')})`,
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    openSelect = () => {
        if (this.props.disabled) {
            return;
        }
        this.setState({
            openSelect: !this.state.openSelect,
        });
    };

    selectColor = (selectedValue) => {
        if (this.props.disabled) {
            return;
        }

        this.setState(
            {
                selectedValue,
                openSelect: false,
            },
            () => {
                this.props.onChange(this.props.name, this.state.selectedValue);
            }
        );
    };

    render() {
        const { className = 'w-full', placeholder } = this.props;
        const { selectedValue, options, openSelect } = this.state;
        return (
            <div className="w-full relative" ref={this.parentRef}>
                <div
                    ref={this.dropdownRef}
                    className={twclsx(
                        'relative',
                        'py-1',
                        'px-2',
                        'border',
                        'border-gray-400',
                        'rounded',
                        'focus:border-focused',
                        'focus:shadow-input',
                        'focus:outline-none',
                        className
                    )}
                >
                    <div onClick={this.openSelect} className="flex justify-between align-middle cursor-pointer ">
                        <div>
                            {selectedValue
                                ? //@ts-ignore
                                  this.renderColor(selectedValue, options[selectedValue])
                                : translate(placeholder || 'Select color range')}{' '}
                        </div>

                        <div>
                            <Icon className="w-4 h-4 mt-1">
                                {openSelect ? <path d="M6 15l6 -6l6 6"></path> : <path d="M6 9l6 6l6 -6"></path>}
                            </Icon>
                        </div>
                    </div>
                </div>
                {openSelect && (
                    <div className="w-full top-8 border border-gray-300  rounded-sm bg-white absolute">
                        <div className="p-3">
                            {Object.keys(options).map((palette) => {
                                return this.renderColor(palette, options[palette]);
                            })}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ColorRangeSelect;
